import type { ReactNode } from 'react'
import type { HTMLXStyledProps } from '@mote/ui/system'
import { useViewportWidth, x } from '@xstyled/styled-components'

export interface HalfSplitLayoutProps extends HTMLXStyledProps<'div'> {
  rightContent: ReactNode
  leftContent: ReactNode
  breakpointThreshold?: number
}

export const HalfSplitLayout = (props: HalfSplitLayoutProps): JSX.Element => {
  const {
    rightContent,
    leftContent,
    breakpointThreshold = 992,
    ...rest
  } = props
  const viewportWidth = useViewportWidth()
  const isBelowThreshold = viewportWidth && viewportWidth < breakpointThreshold

  return (
    <x.div
      display='grid'
      w='full'
      minH='full'
      gridTemplateColumns={isBelowThreshold ? 1 : 2}
      {...rest}
    >
      {leftContent}
      {!isBelowThreshold && rightContent}
    </x.div>
  )
}
